import ContextedDispatcher from "data/util/ContextedDispatcher";
import invariant from "invariant";
import { ACTION_CONTEXT_KEY } from "data/util/ContextedReduceStore";
import PropTypes from "prop-types";
import {
    actionGroupInConsole,
    logActionToConsole,
} from "data/dev/logActionToConsole";

const _global = window || {};
if (_global.__flux_dispatcher_created && !_global.testEnv) {
    throw new Error("You've got something screwy, multiple Dispatchers were 'require'-ed");
}
_global.__flux_dispatcher_created = true;

const checkAction = action => {
    invariant(
        ! action.hasOwnProperty(ACTION_CONTEXT_KEY),
        `You may not dispatch actions containing a '${ACTION_CONTEXT_KEY}' key.`
    );
    invariant(
        action.type,
        "Actions must have a 'type' key"
    );
    if (action.type.actionTypes != null) {
        PropTypes.checkPropTypes(action.type.actionTypes, {action}, "actionTypes", action.type);
    }
};

// yeah, i know. compose, don't extend. shush.

class ValidatingDispatcher extends ContextedDispatcher {

    constructor(enableLogging = false) {
        super();
        this._enableLogging = enableLogging;
    }

    register(callback) {
        const token = super.register(callback);
        if (this._enableLogging && callback === logActionToConsole) {
            // tee-hee
            this.unregister(token);
        }
        return token;
    }

    _startDispatching(action) {
        if (this._enableLogging && actionGroupInConsole(action)) {
            this._start = Date.now();
        }
        super._startDispatching(action);
    }

    _stopDispatching() {
        super._stopDispatching();
        if (this._enableLogging && this._start) {
            const elapsed = Date.now() - this._start;
            elapsed > 20 && console.warn(elapsed + "ms");
            console.groupEnd();
            delete this._start;
        }
    }

    dispatch(action) {
        checkAction(action);
        invariant(
            action.type.charAt(0) !== "*",
            `Action '${action.type}' MUST be dispatched contextually`
        );
        super.dispatch(action);
    }

    contextDispatch(context, action) {
        invariant(
            typeof context === "string" && context,
            "Contexts must be named by non-empty strings"
        );
        checkAction(action);
        super.contextDispatch(context, action);
    }
}

export default process.env.NODE_ENV === "production"
    ? new ContextedDispatcher()
    : new ValidatingDispatcher(false);



// WEBPACK FOOTER //
// ./app/Dispatcher.js